/**
 * VP-CUST-002 Phase-1 scope: the backend has no favorites/wishlist entity
 * (confirmed — Phase 2 scope, same finding as the vin-pulse-os-web Customer
 * Portal batch). Rather than block the "Favorites" catalog filter on new
 * backend work, this is a simple client-side, localStorage-backed favorites
 * toggle. It is scoped to the browser, not the account — a documented
 * Phase-1 fallback, not a real per-customer preference.
 *
 * Mirrors vin-pulse-os-web/src/utils/favoritesStore.ts.
 */

const STORAGE_KEY = 'vinpulse_ecom_favorite_skus';

function readAll(): Set<string> {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    return new Set(Array.isArray(arr) ? arr.map(String) : []);
  } catch {
    return new Set();
  }
}

function writeAll(ids: Set<string>): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(ids)));
  } catch {
    // ignore — favorites are a client-side convenience, not critical state
  }
}

export function isFavoriteSku(skuId: string | number): boolean {
  return readAll().has(String(skuId));
}

export function getFavoriteSkuIds(): Set<string> {
  return readAll();
}

export function toggleFavoriteSku(skuId: string | number): boolean {
  const ids = readAll();
  const key = String(skuId);
  let nowFavorite: boolean;
  if (ids.has(key)) {
    ids.delete(key);
    nowFavorite = false;
  } else {
    ids.add(key);
    nowFavorite = true;
  }
  writeAll(ids);
  return nowFavorite;
}
